import {
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuItem,
} from '@cad-arc';
import { InitiateSubmenuView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useCallback } from 'react';
import { useOpenEventPanel } from '../event-panel/use-open-event-panel';
import { getSelfInitiateOptions } from '../common/helpers/self-initiate-options';

export function InitiateSubmenu({
    initiateSubmenuView,
    clickParams,
}: {
    initiateSubmenuView: InitiateSubmenuView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const openEventPanel = useOpenEventPanel();
    const handleSelect = useCallback(
        (selfInitiateAttrId: number) => {
            openEventPanel({
                workspacePanelConfig: {
                    panelState: {
                        selfInitiate: {
                            ...getSelfInitiateOptions(initiateSubmenuView, selfInitiateAttrId),
                            unitId: clickParams.unitId,
                        },
                    },
                },
            });
        },
        [clickParams.unitId, initiateSubmenuView, openEventPanel]
    );

    const options = [
        ...initiateSubmenuView.initiateCallForServiceOptions,
        ...initiateSubmenuView.initiateAttributeOptions,
    ];

    return initiateSubmenuView.isVisible ? (
        <ContextMenuSub>
            <ContextMenuSubTrigger
                data-pendo-id="menu-item-initiate"
                isDisabled={!initiateSubmenuView.isEnabled}
            >
                {initiateSubmenuView.label}
            </ContextMenuSubTrigger>
            <ContextMenuSubContent style={{ maxHeight: '100vh' }}>
                {options.map((attr) => {
                    return (
                        <ContextMenuItem key={attr.value} onSelect={() => handleSelect(attr.value)}>
                            {attr.label}
                        </ContextMenuItem>
                    );
                })}
            </ContextMenuSubContent>
        </ContextMenuSub>
    ) : (
        <></>
    );
}
